<template>
  <div class="search-wrap">
    <Form
      ref="searchForm"
      label-position="right"
      :label-width="0"
      class="search-list-430 search-wrapper-430"
    >
      <Row class="relative" type="flex" flex="end">
        <FormItem label="">
          <Input
            v-model="searchConds.configId"
            clearable
            placeholder="请输入分账规则ID"
            class="search-input-430"
          ></Input>
        </FormItem>
        <FormItem label="">
          <Input
            v-model="searchConds.configName"
            clearable
            placeholder="请输入分账规则名称"
            class="search-input-430"
          ></Input>
        </FormItem>
        <FormItem label="">
          <Select v-model="searchConds.inAccountType" class="search-select-430">
            <Option
              v-for="item in bankList"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="">
          <ChooseSchool
            ref="chooseSchool"
            @on-change="onSchChange"
          ></ChooseSchool>
        </FormItem>
        <FormItem label="">
          <Select
            v-model="searchConds.isEnable"
            placeholder="请选择状态规则"
            class="search-select-430"
          >
            <Option
              v-for="item in statusList"
              :key="item.value"
              :value="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <Button type="primary" style="margin-right: 16px" @click="handleSearch"
          >查询</Button
        >
        <Button @click="handleReset">重置</Button>
      </Row>
    </Form>
  </div>
</template>

<script>

import ChooseSchool from '@c/searchBlock/ChooseSchool';
import orderCenterApi from '@/request/orderCenter/index.js';
export default {
  components: {
    ChooseSchool
  },
  data() {
    return {
      bankList: [{
        value: -1,
        label: '选择监管银行'
      }, {
        value: 1,
        label: '平安见证宝'
      }, {
        value: 2,
        label: '工银聚富通'
      }, {
        value: 3,
        label: '微信支付'
      }],
      searchConds: {
        configName: '',
        configId: '',
        inAccountType: -1,
        schoolId: '',
        isEnable: -1
      },
      statusList: [{
        value: -1,
        label: '规则状态'
      }, {
        value: 1,
        label: '开启'
      }, {
        value: 0,
        label: '已关闭'
      }]

    };
  },
  created() {
    // this.getFindBankList()
  },
  methods: {
    // 获取银行列表
    async getFindBankList() {
      const res = await orderCenterApi.getFindBankList();
      if (res.status == 200) {
        this.bankList = [{
          bankId: '-1',
          bankName: '全部'
        }, ...res.message];
      }
    },
    onSchChange(info) {
      this.searchConds.schoolId = info.schoolId;
      console.log(info.schoolId);
    },
    handleSearch() {
      const info = JSON.parse(JSON.stringify(this.searchConds));
      for (const k in info) {
        if (info[k] == -1) {
          delete info[k];
        }
      }
      this.$emit('on-search', info);
    },
    handleReset() {
      this.$refs.chooseSchool.clear();
      this.searchConds = {
        configName: '',
        configId: '',
        bankId: '-1',
        schoolId: '',
        isEnable: -1
      };
      this.handleSearch();
    }
  }

};
</script>

<style>
</style>
